import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export default function ActionButton({ icon: Icon, label, description, onClick }) {
  return (
    <Card
      className="p-4 hover:shadow-md transition-smooth cursor-pointer group border hover:border-primary/30"
      onClick={onClick}
    >
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center group-hover:bg-primary group-hover:text-primary-foreground transition-smooth">
          <Icon className="w-5 h-5" />
        </div>
        <h4 className="font-semibold text-foreground">{label}</h4>
      </div>
      <p className="text-sm text-muted-foreground ml-13">{description}</p>
    </Card>
  );
}
